module.exports = __webpack_public_path__ + "static/media/living-space_dark.e5b30b46.jpg";